declare global {
  interface Window {
    __APP_CONFIG__: {
      API_URL: string;
      COGNITO_USER_POOL_ID: string;
      COGNITO_CLIENT_ID: string;
      AWS_REGION: string;
      WEBSOCKET_URL: string;
    };
  }
}

export const AppConfig = {
  apiUrl: window.__APP_CONFIG__.API_URL,
  cognitoUserPoolId: window.__APP_CONFIG__.COGNITO_USER_POOL_ID,
  cognitoClientId: window.__APP_CONFIG__.COGNITO_CLIENT_ID,
  awsRegion: window.__APP_CONFIG__.AWS_REGION,
  websocketUrl: window.__APP_CONFIG__.WEBSOCKET_URL,
};
